// extracted by mini-css-extract-plugin
export default {"footer":"My2rGaIt","mobile":"mobile","desktop":"desktop","menu":"S9QqXqcV","menuItem":"geMTFA38","link":"Sfa5nara","logo":"JtFRzFXC"};